import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { mediaUrl } from "../../lib/config/app";
export default function ProductImage(t0) {
  const $ = _c(3);
  const {
    product
  } = t0;
  const imageAlt = product?.featured_image_alt || product?.title || "Product Image";
  const t1 = `${mediaUrl}${product?.featured_image || "noimage.png"}`;
  let t2;
  if ($[0] !== imageAlt || $[1] !== t1) {
    t2 = <div className="relative aspect-square"><Image src={t1} alt={imageAlt} fill={true} quality={60} sizes="(max-width: 768px) 45vw, 15vw" className="object-contain rounded-t-lg" /></div>;
    $[0] = imageAlt;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}